import { AlertDialog, AlertDialogContent } from "~/components/ui/alert-dialog";
import { Spinner } from "~/components/ui/spinner";

interface AlertDialogLoadingProps {
  message?: string;
  onOpenChange: () => void;
}

export function AlertDialogLoading({
  message = "Loading...",
  onOpenChange,
}: AlertDialogLoadingProps) {
  return (
    <AlertDialog onOpenChange={onOpenChange} open>
      <AlertDialogContent>
        <div className="flex flex-col items-center justify-center gap-3 py-8 text-center">
          <Spinner className="size-6" />
          <p className="body-sm text-muted-foreground">{message}</p>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
